import { Injectable, Injector } from '@angular/core';
import { BaseResourceService } from '../../models/services/base-resource.service';
import { PendenciaAssinatura } from 'eddydata-lib';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PendenciaAssinaturaService extends BaseResourceService<PendenciaAssinatura> {

  constructor(
    protected injector: Injector
  ) {
    super(`pendencias-assinaturas`, injector);
  }

  getAlias(): Observable<any> {
    return this.http.get('http://localhost:4567/api/assinar/alias');
  }

}
